/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_EnteredInputs */

const th_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครแล้ว`)
};

const en_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entered`)
};

const ja_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申込済み`)
};

const zh_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已报名`)
};

const es_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrito`)
};

const pt_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrito`)
};

const id_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terdaftar`)
};

const fr_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrite`)
};

const tl_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali na`)
};

const vi_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng ký`)
};

const ko_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`참가함`)
};

const de_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeldet`)
};

const ru_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявлена`)
};

const tr_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydolundu`)
};

const it_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscritta`)
};

const pl_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoszona`)
};

const uk_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявлена`)
};

const hi_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकृत`)
};

const ar_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسجَّل`)
};

const ms_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berdaftar`)
};

const bn_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিবন্ধিত`)
};

const zh_tw2_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已報名`)
};

const zh_hk2_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已報名`)
};

const ur_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجسٹرڈ`)
};

const fa_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت‌شده`)
};

const sw_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imesajiliwa`)
};

const nl_event_entered = /** @type {(inputs: Event_EnteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeschreven`)
};

/**
* | output |
* | --- |
* | "Entered" |
*
* @param {Event_EnteredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_entered = /** @type {((inputs?: Event_EnteredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_EnteredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_entered(inputs)
	if (locale === "ja") return ja_event_entered(inputs)
	if (locale === "zh") return zh_event_entered(inputs)
	if (locale === "es") return es_event_entered(inputs)
	if (locale === "pt") return pt_event_entered(inputs)
	if (locale === "id") return id_event_entered(inputs)
	if (locale === "fr") return fr_event_entered(inputs)
	if (locale === "tl") return tl_event_entered(inputs)
	if (locale === "vi") return vi_event_entered(inputs)
	if (locale === "ko") return ko_event_entered(inputs)
	if (locale === "de") return de_event_entered(inputs)
	if (locale === "ru") return ru_event_entered(inputs)
	if (locale === "tr") return tr_event_entered(inputs)
	if (locale === "it") return it_event_entered(inputs)
	if (locale === "pl") return pl_event_entered(inputs)
	if (locale === "uk") return uk_event_entered(inputs)
	if (locale === "hi") return hi_event_entered(inputs)
	if (locale === "ar") return ar_event_entered(inputs)
	if (locale === "ms") return ms_event_entered(inputs)
	if (locale === "bn") return bn_event_entered(inputs)
	if (locale === "zh-TW") return zh_tw2_event_entered(inputs)
	if (locale === "zh-HK") return zh_hk2_event_entered(inputs)
	if (locale === "ur") return ur_event_entered(inputs)
	if (locale === "fa") return fa_event_entered(inputs)
	if (locale === "sw") return sw_event_entered(inputs)
	if (locale === "nl") return nl_event_entered(inputs)
	return en_event_entered(inputs)
});